// Basic
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useRootOrganizationStore from '@/app/store/rootOrganization';
import usePlansStore from '@/app/store/modules/plan';
import actionsPlans from '../../api/actionsPlans';
// Components
import DataTable from '@/common-utils/components/renders/dataTable/DataTable';
// Common
import getInitialQuery from '@/common-utils/components/renders/dataTable/utils/getInitialQuery';
import mergeQuery from '@/common-utils/components/renders/dataTable/utils/mergeQuery';
import { columnsParentPlans, columnsParentPlansId } from './columnsDef/columnsParentPlans';

/**
 * @param root0
 * @param root0.customQuery
 * @param root0.singleSelection
 * @param root0.rowsSelected
 * @param root0.setRowsSelected
 * @param root0.organizationId
 * @param root0.pageActions
 * @param root0.filtersEventName
 *@returns {JSX} PlansTable
 */
function ParentPlansTable({
    customQuery = {},
    singleSelection = false,
    rowsSelected = undefined,
    setRowsSelected = undefined,
    organizationId = undefined,
    pageActions = undefined,
    filtersEventName
}) {
    // Store
    const rootOrganization = useRootOrganizationStore(s => s.rootOrganization);
    const { refetchPlans: launchRefetchFromStore, storeRefetchPlans: setLaunchRefetchFromStore, query: queryStored, storeQuery } = usePlansStore();

    // Constants
    const initialQuery = getInitialQuery(customQuery);
    const selectionMode = !!(rowsSelected && setRowsSelected);
    const displayRowActions = rootOrganization.uuid !== organizationId;

    // State
    const [query, setQuery] = useState(mergeQuery(initialQuery, queryStored));
    const [launchRefetch, setLaunchRefetch] = useState(true);

    // Api Calls
    const { data, isFetching, refetch } = actionsPlans.getParentPlans({ query: query, organizationId: organizationId || rootOrganization.uuid }, false);

    // Hooks
    useEffect(() => {
        if (organizationId || rootOrganization) {
            refetch();
            setLaunchRefetch(false);
            setLaunchRefetchFromStore(false);
        }
    }, [query, launchRefetch, launchRefetchFromStore]);

    // Columns
    const allColumns = columnsParentPlans({
        query, setQuery, queryStored, storeQuery, setLaunchRefetch, selectionMode, singleSelection,
        displayParentPlanLabel: true, organizationId, displayRowActions, filtersEventName
    });

    return (
        <DataTable
            filtersEventName={filtersEventName}
            columns={allColumns}
            data={data}
            dataFetchingIsLoading={isFetching}
            columnsId={columnsParentPlansId}
            initialQuery={initialQuery}
            query={query}
            setQuery={setQuery}
            queryStored={queryStored}
            storeQuery={storeQuery}
            setLaunchRefetch={setLaunchRefetch}

            selectionMode={selectionMode}
            singleSelection={singleSelection}
            rowsSelected={rowsSelected}
            setRowsSelected={setRowsSelected}

            pageActions={pageActions}
        />
    );
}

ParentPlansTable.propTypes = {
    customQuery: PropTypes.object,
    singleSelection: PropTypes.bool,
    rowsSelected: PropTypes.any,
    setRowsSelected: PropTypes.func,
    organizationId: PropTypes.string,
    pageActions: PropTypes.node,
    filtersEventName: PropTypes.string
};

export default ParentPlansTable;